import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import Backdrop from '../../../../common/modal/Backdrop'
import Modal from '../../../../common/Modal'
import ModalInnerWrapper from '../../../../common/ModalInnerWrapper'
import PannelBody from '../../../../fragments/PannelBody'
import Button from '../../../../common/Button'
import InputBox from '../../../../common/interactive/InputBox'
import { saveInvalidFaxApi } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import classes from './InvalidFaxWorkQ.module.css'

export default function InvalidFaxEditModal({ item, onClose, onSaved }) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const [fax, setFax] = useState(item?.fax || '')
    const [saving, setSaving] = useState(false)

    async function saveHandler(event) {
        event.preventDefault()
        if (!userToken || !item) {
            return
        }

        setSaving(true)
        const result = await saveInvalidFaxApi(userToken, item.type, item.id, fax)
        setSaving(false)

        if (!result || result.errorMessage || result.status) {
            const message = typeof result?.errorMessage === 'string'
                ? result.errorMessage
                : 'The fax could not be saved.'
            dispatch(notificationActions.setError({ errorMessage: message }))
            return
        }

        dispatch(notificationActions.setError({ errorMessage: 'Fax saved', type: 'success' }))
        onSaved(result)
    }

    return <>
        {ReactDOM.createPortal(
            <Backdrop hide={onClose} hideEnabled />,
            document.getElementById('backdrop-root')
        )}
        {ReactDOM.createPortal(
            <Modal>
                <ModalInnerWrapper closeModal={onClose} modalTitle="Edit fax" setWidth="420px">
                    <PannelBody>
                        <form onSubmit={saveHandler}>
                            <p className={classes.edit_name}>{item.name}</p>
                            <div className={classes.edit_field}>
                                <InputBox
                                    label="Fax"
                                    name="invalid-fax-input"
                                    currentValue={fax}
                                    action={(payload) => setFax(payload?.data?.value ?? '')}
                                />
                            </div>
                            <div className={classes.edit_actions}>
                                <Button type="submit" isLoading={saving}>Save</Button>
                                <Button type="button" btnStyle="btn_white" click={onClose}>Cancel</Button>
                            </div>
                        </form>
                    </PannelBody>
                </ModalInnerWrapper>
            </Modal>,
            document.getElementById('overlay-root')
        )}
    </>
}
